import React, { useContext, useEffect, useState } from "react";
import Navbar from "./Navbar/Navbar";
import Sidebar from "./Sidebar/Sidebar";
import { Outlet, useParams } from "react-router-dom";
import "../../components/Headers/Header1.scss";
import userContext from "../UseContext/UseContext";
import { FetchProfile } from "../../services/api/profile";
const Header = () => {
  const [open, setopen] = useState(false);
  const { permissionvalues, setPermissionValue, setsubdomain } =
    useContext(userContext);
  const handleClick = () => {
    setopen(!open);
  };
  const { id } = useParams();
  if (id) {
    setsubdomain(id);
    
  }
  const fetchData = async () => {
    const reponse = await FetchProfile(id);
    if (reponse.success) {
      setPermissionValue(reponse.vendor);
    }
  };
  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id]);

  return (
    <div className="d-flex align-items-start">
      <Sidebar open={open} />
      <div className="w-100 sid-wd">
        <Navbar handleClick={handleClick} />
        <div className="layout-body">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Header;
